import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import db from './modules/db'
import systems from './modules/systems'
import getters from './getters'
import auth from './modules/auth'
import tableConfig from './modules/tableConfig'
import reimbursementConfig from './modules/reimbursementManagement/index' // 报销管理



Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    tableConfig,
    reimbursementConfig,
    auth,
    app,
    user,
    systems,
    db
  },
  getters
})

export default store
